<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <template>
            <ItemIndexFilterNotification
                :show="filter.show"
                :type="filter.type"
                :term="filter.term"
            />
            <v-data-table
                :search="searchTerm"
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :loading="tableLoading"
            >
                <template #item.name="{ item }">
                    <v-btn
                        x-small
                        :to="'/step/edit/' + item.id"
                        color="primary"
                    >
                        {{ item.name }}
                        <v-icon
                            right
                            x-small
                        >
                            fas fa-edit
                        </v-icon>
                    </v-btn>
                </template>
                <template #item.published="{ item }">
                    <v-icon
                        small
                        color="primary"
                        v-if="item.published === 1"
                    >
                        fas fa-check-circle
                    </v-icon>
                    <v-icon
                        small
                        color="error"
                        v-else
                    >
                        fas fa-minus-circle
                    </v-icon>
                </template>
            </v-data-table>
        </template>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';
export default {
    mixins: [ ItemIndexBoilerplate ],

    data() {
        return {
            indexType: 'step',
            singularName: 'Step',
            pluralName: 'Steps',
            responseObject: 'steps',
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Level',
                    value: 'level',
                },
                {
                    text: 'Order',
                    value: 'order',
                },
                {
                    text: 'Published',
                    value: 'published',
                    align: 'right',
                },
            ],
        };
    },
};
</script>
